import { render, staticRenderFns } from "./GoogleLogo.vue?vue&type=template&id=09b5ac72&scoped=true"
import script from "./GoogleLogo.vue?vue&type=script&lang=js"
export * from "./GoogleLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b5ac72",
  null
  
)

export default component.exports